module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAA5BAMAAAC/sdQaAAAAG1BMVEVHcEw8nL08m708m7s8nLw+n788nL09nb09nL33QEGgAAAACHRSTlMAf8BAvxLQWFrngZUAAACXSURBVDjLY+hABakMENChhAw02gIgwi0MyIADprwJVTgNqhxNWDUjFZuwQhhEObowK0Q5ujADRDmGMEQ5hjBEOaYwWDmmMFg5FmGQcpAwOziUCsCeB4M2sDAjmG2AEO5AMwQWrDQXZhVEAgFwYUbkSBYgpHoA3M2O7MACQsKDPmBDB03AMg72gKWVcIcLFgAUxgoYjLECAGM3mB8Juhw8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/file.png
// module id = g1gp
// module chunks = 1